import { forwardRef, ForwardedRef } from 'react'
import Button from '@mui/material/Button'
import { buttonDestructiveStyles } from './Button.styles'
import { ButtonProps } from './Button.types'
import { SxProps } from '@mui/system'

const ButtonDestructive = forwardRef(
  (
    {
      children,
      size = 'large',
      disabled = false,
      loading = false,
      sx = {},
      ...extraProps
    }: ButtonProps,
    ref: ForwardedRef<any>
  ) => {
    return (
      <Button
        ref={ref}
        sx={{ ...buttonDestructiveStyles, ...sx } as SxProps}
        variant="contained"
        color="primary"
        size={size}
        {...extraProps}
        disabled={disabled || loading}
      >
        {children}
      </Button>
    )
  }
)

export default ButtonDestructive
